import { FC, memo } from 'react';
import Location from '../../containers/Location/Location';
import MainDetails from '../../containers/MainDetails/MainDetails';
import OrderSettings from '../../containers/OrderSettings/OrderSettings';
import BranchProfileLink from '~/view/screens/BranchesManagementScreen/screens/BranchEditScreen/components/BranchProfileLink/BranchProfileLInk';
import BranchOrderTypes from '../../components/BranchOrderTypes/BranchOrderTypes';

const BranchDetails: FC = (): JSX.Element => {
  return (
    <>
      <div className="d-flex fle-column gap-40">
        <MainDetails />
        <Location />
      </div>

      <OrderSettings />
      <BranchOrderTypes />
      <BranchProfileLink />
    </>
  );
};

export default memo(BranchDetails);
